import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Row, Col, Button, Container, Form, Modal, Input } from "reactstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import CustomInput from "Custom/CustomInput";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import CustomFlatpickr from "Custom/CustomFlatpicker";
import { del, get, post, postFormData } from "helpers/api_helper";
import {
  GET_InvoiceOrganisationDetail,
  POST_UploadDocumnet,
  GET_GroupTermsCondition,
  DELETE_poImage,
  POST_ORG_INVOICE,
  GET_ContactTypeCustomer,
  GET_ORG_INVOICE_DETAIL,
} from "helpers/url_helper";
import { Spin } from "antd";
import swal from "sweetalert";
import moment from "moment";
import SwalError from "Custom/SwalError";
import CustomSelect from "Custom/CustomSelect";

const AddInvoice = (props) => {
  const navigate = useNavigate();
  const { IdParam } = useParams();
  const [PONoModal, setPONoModal] = useState(false);
  const [editTermsAndConditionModal, setEditTermsAndConditionModal] = useState(
    false
  );
  const [disclaimerModal, setDisclaimerModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showSwalError, setShowSwalError] = useState(false);
  const [swalErrorMsg, setSwalErrorMsg] = useState("");
  const [orgBilling, setOrgBilling] = useState({});
  const [orgShipping, setOrgShipping] = useState({});
  const [supplyInfo, setSupplyInfo] = useState({});
  const [customerOptions, setCustomerOptions] = useState([]);
  const [orgName, setOrgName] = useState(null);

  const initialFileUpload = {
    File: "",
  };

  const validationSchema = Yup.object().shape({
    invoice_no: Yup.string().required("Invoice Number# is a required field."),
    contact_id: Yup.string().required("Customer is a required field."),
    grand_total: Yup.number().required("Total Amount is a required field."),
    ListOffileUpload: Yup.array()
    .of(
      Yup.object().shape({
        File: Yup.mixed().required("File is required"),
      })
    )
    .min(1, "Attach at least one file"),
  });

  const formatAddress = (item) => {
    const addressParts = [
      item.address_line_1,
      item.address_line_2,
      item.address_line_3,
      [item?.city_name, item?.state_name].filter(Boolean).join(", "),
      [item?.country_name, item.zip_code].filter(Boolean).join(" - "),
    ].filter(Boolean);

    return addressParts.join(",<br/>");
  };

  const formik = useFormik({
    validationSchema: validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      organization_id: 1,
      invoice_no: "",
      grand_total: 0,
      source_of_supply: 0,
      source_of_supply_name: "",
      destination_of_supply: 0,
      destination_of_supplyStateName: "",
      invoice_date: new Date(),
      notes: "",
      currency_id: 1,
      file_manager_id: [],
      button: "Save",
      order_file: [],
      contact_id: "",
      ListOffileUpload: [initialFileUpload],
    },
    validateOnBlur: false,
  });

  const {
    setValues,
    setFieldValue,
    values: { ListOffileUpload, order_file, tc_group_list_id, invoice_status },
  } = formik;

  const getCustomerList = () => {
    setIsLoading(true);
    get(GET_ContactTypeCustomer + "&paginate=1000&page=1").then((res) => {
      if (res?.data?.data?.length > 0) {
        let NewOptions = [];
        // console.log("cust", res?.data?.data)
        res?.data?.data?.map((item) =>
          NewOptions.push({
            label: item?.company_name,
            value: item?.contact_id,
          })
        );
        setCustomerOptions(NewOptions);
      }
    });
    setIsLoading(false);
  };

  useEffect(() => {
    getCustomerList();
    getOrganizationDetails();

    if (IdParam) {
      get(GET_ORG_INVOICE_DETAIL + `${IdParam}`).then((res) => {
        if (res.status === 200) {
          setFieldValue("contact_id", res?.data?.contact_id);
          setFieldValue("invoice_no", res?.data?.invoice_no);
          setFieldValue("grand_total", res?.data?.grand_total);
          setFieldValue("invoice_date", res?.data?.invoice_date);
          setFieldValue("notes", res?.data?.notes);
          setFieldValue("order_file", res?.data?.files);
        }
      });
    }
  }, []);

  const getOrganizationDetails = async () => {
    setIsLoading(true);
    let headers = {
      Authorization: `Bearer ${
        JSON.parse(localStorage.getItem("authUser"))?.auth?.token
      }`,
    };
    await get(GET_InvoiceOrganisationDetail + "/1", headers)
      .then((res) => {
        if (res?.status == 200) {
          setOrgName(res.data.display_name);
          if (res?.data?.org_addresses?.length > 0) {
            setFieldValue(
              "destination_of_supply",
              res?.data?.supply_state_code
            );
            setFieldValue(
              "destination_of_supplyStateName",
              (res?.data?.supply_state?.vehicle_series_code
                ? `[${res?.data?.supply_state?.vehicle_series_code}] `
                : "") + res?.data?.supply_state?.state_name
            );
            setFieldValue("source_of_supply", res?.data?.supply_state?.id);
            setFieldValue(
              "source_of_supply_name",
              `[${res?.data?.supply_state?.vehicle_series_code}] ${res?.data?.supply_state?.state_name}`
            );
            const lastShipping = res?.data?.org_addresses
              .filter((address) => address.type === "shipping")
              .pop();
            const lastBilling = res?.data?.org_addresses
              .filter((address) => address.type === "billing")
              .pop();
            setOrgBilling(lastBilling);
            setOrgShipping(lastShipping);
          }
          setSupplyInfo(res?.data?.supply_state);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const initialListofPurchaseOrderNumber = {
    Prefix: "",
    NextNumber: "",
    Default: false,
    AddManually: false,
  };

  const validationSchemaPONo = Yup.object().shape({});

  const formikPONo = useFormik({
    validationSchema: validationSchemaPONo,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitPONo(values, formikHelpers),
    initialValues: {
      Setting: false,
      AddManually: true,
      ListofPurchaseOrderNumber: [initialListofPurchaseOrderNumber],
    },
    validateOnBlur: false,
  });

  const {
    values: { Setting, ListofPurchaseOrderNumber, AddManually },
  } = formikPONo;

  const handleValidSubmitPONo = (values) => {
    setPONoModal(false);
  };

  const validationSchemaEditTermsAndCondition = Yup.object().shape({});

  const formikEditTermsAndCondition = useFormik({
    validationSchema: validationSchemaEditTermsAndCondition,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitEditTermsAndCondition(values, formikHelpers),
    initialValues: {},
    validateOnBlur: false,
  });

  const {
    values: { termsAndConditionsList },
  } = formikEditTermsAndCondition;

  const handleValidSubmitEditTermsAndCondition = (values) => {
    setFieldValue("tc_list", termsAndConditionsList);
    setFieldValue(
      "tc_display",
      termsAndConditionsList
        ?.filter((x) => x.checked == true)
        ?.map((tc) => {
          return tc.Condition;
        })
        .join(", ")
    );
    setEditTermsAndConditionModal(false);
  };

  useEffect(() => {
    //console.log("tc_group_list_id EFFECT:", termsAndConditionsList)
    if (IdParam) {
      if (tc_group_list_id) {
        get(GET_GroupTermsCondition + tc_group_list_id).then((res) => {
          if (res?.status == 200) {
            let groupIds = res?.data;
            let tcState = [];

            if (termsAndConditionsList?.length > 0) {
              termsAndConditionsList?.map((x) => {
                if (groupIds.filter((g) => g.tandc_id == x.ID).length > 0) {
                  tcState.push({
                    ...x,
                    checked: true,
                  });
                } else {
                  tcState.push({
                    ...x,
                  });
                }
              });

              formikEditTermsAndCondition.setFieldValue(
                "termsAndConditionsList",
                tcState
              );
              setFieldValue("tc_list", tcState);
              setFieldValue(
                "tc_display",
                tcState
                  ?.filter((x) => x.checked == true)
                  ?.map((tc) => {
                    return tc.Condition;
                  })
                  .join(", ")
              );
            }
          }
        });
      }
    }
  }, [tc_group_list_id]);

  const delete_PONumber = (index) => {
    formikPONo.setFieldValue(
      "ListofPurchaseOrderNumber",
      ListofPurchaseOrderNumber.filter((element, i) => i !== index)
    );
  };

  const AddPONumber = () => {
    formikPONo.setFieldValue("ListofPurchaseOrderNumber", [
      ...ListofPurchaseOrderNumber,
      {
        Prefix: "",
        NextNumber: "",
        Default: false,
      },
    ]);
  };

  // const onFileSelect = (e, index) => {
  //   if (e?.target?.files?.length > 0) {
  //     if (Math.round(e?.target?.files[0].size / 1024 / 1024) > 5) {
  //       e.target.value = [];
  //       swal("Attach File(s)", "You can upload file upto 5MB size!", "warning");
  //     } else {
  //       let fileArray = [...ListOffileUpload];
  //       fileArray[index].File = e.target.files[0];
  //       setFieldValue("ListOffileUpload", fileArray);
  //     }
  //   }
  // };

  const onFileSelect = (e, index) => {


    const pattern = /\.(xls|xlsx|doc|docx|pdf|jpg|jpeg|csv|xml)$/i;
    const files = e.target.files;
  
    if (!files || files.length === 0) return;
  
    const selectedFile = files[0];
    const fileName = selectedFile.name;
    const fileSizeMB = selectedFile.size / 1024 / 1024;
  
    const maxFileSizeMB = parseFloat(process.env.REACT_APP_IMAGE_SIZE_LIMIT) || 2;
  
    if (fileSizeMB > maxFileSizeMB) {
      e.target.value = null;
      swal("Attach File(s)", `You can upload file up to ${maxFileSizeMB}MB size!`, "warning");
      return;
    }
  
    if (!pattern.test(fileName)) {
      e.target.value = null;
      swal("", "Only XLS, XLSX, DOC, DOCX, PDF, JPG, CSV, and XML files are allowed!", "warning");
      return;
    }
    setFieldValue(`ListOffileUpload.[${index}].File`, selectedFile); 
  };

  const delete_FileUpload = (index) => {
    formik.setFieldValue(
      "ListOffileUpload",
      ListOffileUpload.filter((element, i) => i !== index)
    );
  };

  const AddFileUpload = () => {
    if (ListOffileUpload?.length < 10) {
      formik.setFieldValue("ListOffileUpload", [
        ...ListOffileUpload,
        {
          File: "",
        },
      ]);
    } else {
      swal("Attach File(s)", "You can upload maximum 10 files!", "warning");
    }
  };

  const delete_uploadedFile = (id, poId, index) => {
    swal({
      title: "Are you sure you want to delete the uploaded file?",
      text: "You won't be able to revert this!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDo) => {
      if (willDo) {
        delete_uploadedFileConfirm(id, poId, index);
      }
    });
  };

  const delete_uploadedFileConfirm = (id, poId, index) => {
    setIsLoading(true);
    del(DELETE_poImage + "?po_id=" + poId + "&file_manager_id=" + id)
      .then((response) => {
        if (response?.status == 200) {
          formik.initialTouchedsetFieldValue(
            "order_file",
            order_file?.filter((x, i) => i != index)
          );
          swal("Delete File", response?.message, "success");
        } else {
          // swal("Delete File", response?.message, "error")
          if (typeof response?.message == "string") {
            swal({
              title: "Delete File!",
              text: response.message,
              icon: "error",
              button: "OK",
            });
          } else {
            setSwalErrorMsg(response?.message);
            setShowSwalError(true);
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleValidSubmit = async (values) => {
    setIsLoading(true);
    let fileManagerId = [];
    await Promise.all(
      values?.ListOffileUpload?.map(async (x) => {
        if (x?.File) {
          let formData = new FormData();
          formData.append("module_slug", "org-purchase-purchase-order");
          formData.append("label", "Attach File");
          formData.append("file", x?.File);
          await postFormData(POST_UploadDocumnet, formData)
            .then((response) => {
              if (response?.status == 200) {
                fileManagerId.push(response?.data?.id);
              } else {
                // swal("Error!", response?.message, "error")
                if (typeof response?.message == "string") {
                  swal({
                    title: "Error!",
                    text: response.message,
                    icon: "error",
                    button: "OK",
                  });
                } else {
                  setSwalErrorMsg(response?.message);
                  setShowSwalError(true);
                }
                setIsLoading(false);
                return;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      })
    );

    if (
      values?.ListOffileUpload?.filter((x) => x?.File != "")?.length > 0 &&
      fileManagerId?.length == 0
    ) {
      return;
    }

    let payload = {
      ...values,
      invoice_date: values.invoice_date
        ? moment(values.invoice_date).format("yyyy-MM-DD")
        : "",
      file_id: fileManagerId,
      id: IdParam ? IdParam : 0,
      invoice_status: values?.button == "Save and Send" ? "sent" : "draft",
    };

    if (!IdParam) {
      delete payload["id"];
    }
    delete payload["ListOffileUpload"];
    delete payload["totalQty"];
    delete payload["tc_list"];
    delete payload["tc_display"];
    delete payload["primary_contact_lname"];
    delete payload["file_manager_id"];
    delete payload["button"];
    delete payload["order_file"];
    delete payload["tds_percentage"];
    delete payload["tds_amount"];
    payload["billing_address_id"] = orgBilling?.id;
    payload["shipping_address_id"] = orgShipping?.id;
    payload["organization_id"] = 1;
    payload["destination_of_supply"] = supplyInfo?.id;

    await post(POST_ORG_INVOICE, payload)
      .then((response) => {
        if (response?.status == 200) {
          swal("Success!", response?.message, "success");
          setIsLoading(false);
          setTimeout(() => {
            navigate("/sales-invoice");
          }, 1000);
        } else {
          // swal("Error!", response?.message, "error")
          if (typeof response?.message == "string") {
            swal({
              title: "Error!",
              text: response.message,
              icon: "error",
              button: "OK",
            });
          } else {
            setSwalErrorMsg(response?.message);
            setShowSwalError(true);
          }
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <React.Fragment>
      <Spin size="large" spinning={isLoading} tip={"Loading..."}>
        <div className="page-content">
          <MetaTags>
            <title>
              {IdParam ? "Edit Purchase Order" : "Add Purchase Order"} | Katlax
              OMS
            </title>
          </MetaTags>

          <Container fluid>
            <Row className="mt-2">
              <Col lg={6}>
                <div style={{ fontSize: "large" }}>
                  <i className="ti-bag" style={{ fontWeight: "800" }}></i>
                  &nbsp;
                  <b>{IdParam ? "Edit Invoice" : "Create Invoice"}</b>
                </div>
              </Col>
            </Row>
            <Row className="mt-3" style={{ borderTop: "1px solid #cacaca" }}>
              <Col className="mt-3">
                <FormikProvider value={formik}>
                  <Form onSubmit={formik.handleSubmit}>
                    <Row>
                      <Col lg={2}>
                        <div className="mt-2" style={{ color: "#000000" }}>
                          Organization
                        </div>
                      </Col>
                      <Col lg={3}>
                        <Row className="mt-2">
                          <Col lg={12}>{orgName}</Col>
                          <Col lg={12}>BILLING ADDRESS</Col>
                          <Col lg={12}>
                            {orgBilling ? (
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: formatAddress(orgBilling),
                                }}
                              />
                            ) : (
                              ""
                            )}
                          </Col>
                        </Row>
                      </Col>
                      <Col lg={3}>
                        <Row className="mt-2">
                          <Col lg={12}>SHIPPING ADDRESS</Col>
                          <Col lg={12}>
                            {orgShipping ? (
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: formatAddress(orgShipping),
                                }}
                              />
                            ) : (
                              ""
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col lg={2}>
                        <div className="mt-2" style={{ color: "#000000" }}>
                          Customer Name
                        </div>
                      </Col>
                      <Col lg={5}>
                        <Field
                          name="contact_id"
                          placeholder={"Customer Name"}
                          component={CustomSelect}
                          maxLength={50}
                          options={customerOptions}
                        />
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col lg={2}>
                        <div className="mt-2" style={{ color: "#000000" }}>
                          Source of Supply{" "}
                          <span className="text-danger">*</span>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <Field
                          type="text"
                          name="source_of_supply_name"
                          component={CustomInput}
                          readOnly
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={2}>
                        <div style={{ color: "#000000" }}>
                          Destination Of Supply{" "}
                          <span className="text-danger">*</span>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <Field
                          type="text"
                          name="destination_of_supplyStateName"
                          // value={"[MH] Maharashtra"}
                          // placeholder={"Enter Destination Of Supply"}
                          component={CustomInput}
                          readOnly
                        />
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col lg={2}>
                        <div className="mt-2" style={{ color: "#000000" }}>
                          Invoice Number# <span className="text-danger">*</span>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div className="d-flex">
                          <Field
                            type="text"
                            name="invoice_no"
                            placeholder={"Enter Invoice Number"}
                            component={CustomInput}
                            style={{ textTransform: "Uppercase" }}
                          />
                          &nbsp; &nbsp;
                          <Link
                            onClick={() => {
                              setPONoModal(true);
                            }}
                            className="mt-2"
                            title="Edit"
                          >
                            <i className="ti-settings"></i>
                          </Link>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={2}>
                        <div className="mt-2" style={{ color: "#000000" }}>
                          Total Amount
                        </div>
                      </Col>
                      <Col lg={4}>
                        <Field
                          type="number"
                          name="grand_total"
                          placeholder={"Enter Total Amount"}
                          component={CustomInput}
                          style={{ textTransform: "Uppercase" }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={2}>
                        <div className="mt-2" style={{ color: "#000000" }}>
                          Date
                        </div>
                      </Col>
                      <Col lg={4}>
                        <Field
                          type="text"
                          name="invoice_date"
                          placeholder={"dd/mm/yyyy"}
                          component={CustomFlatpickr}
                          options={{
                            altInput: true,
                            altFormat: "d/m/Y",
                            dateFormat: "d/m/Y",
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={5} style={{ verticalAlign: "bottom" }}>
                        <Field
                          label="Notes"
                          type="textarea"
                          name="notes"
                          placeholder={"Enter Notes"}
                          component={CustomInput}
                          rows={3}
                          style={{ resize: "none" }}
                        />
                      </Col>
                      <Col lg={1}></Col>
                      <Col lg={5} style={{ borderLeft: "1px solid #cacaca" }}>
                        <Row>
                          {order_file?.length > 0 ? (
                            <>
                              <Col lg={11}>
                                {order_file?.map((x, index) => (
                                  <Row>
                                    <Col lg={11}>
                                      <div className="d-flex justify-content-between">
                                        {x?.file ? (
                                          <Link
                                            to={x?.file?.file_url}
                                            title="View"
                                            target="blank"
                                          >
                                            {x?.file?.file_name}
                                          </Link>
                                        ) : (
                                          "File not found"
                                        )}
                                        {/* <Link
                                          to="#"
                                          title="Delete"
                                          onClick={() => {
                                            delete_uploadedFile(
                                              x?.id,
                                              x?.org_purchase_orders_id,
                                              index
                                            );
                                          }}
                                        >
                                          <i
                                            className="fas fa-trash-alt"
                                            style={{
                                              color: "red",
                                            }}
                                          ></i>
                                        </Link> */}
                                      </div>
                                    </Col>
                                  </Row>
                                ))}
                              </Col>
                              <hr className="mt-2"></hr>
                            </>
                          ) : (
                            ""
                          )}
                          <Col lg={12}>{"Attach File(s) to Invoice Order"}</Col>

                          {ListOffileUpload?.map((files, index) => (
                            <Col lg={9} className="mt-2" key={index}>
                              <div className="d-flex">
                                <input
                                  type="file"
                                  className={`form-control ${
                                    formik.errors.ListOffileUpload &&
                                    formik.errors.ListOffileUpload[index] &&
                                    formik.touched.ListOffileUpload &&
                                    formik.touched.ListOffileUpload[index]
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  name={`ListOffileUpload[${index}].File`}
                                  onChange={(e) => onFileSelect(e, index)}
                                  onBlur={formik.handleBlur}
                                />
                                &nbsp;&nbsp;
                                <i
                                  className="fas fa-times-circle"
                                  style={{ color: "red", marginTop: "12px" }}
                                  onClick={() => delete_FileUpload(index)}
                                ></i>
                              </div>
                              {formik.errors.ListOffileUpload &&
                                formik.errors.ListOffileUpload[index] &&
                                formik.touched.ListOffileUpload &&
                                formik.touched.ListOffileUpload[index] && (
                                  <div className="invalid-feedback d-block">
                                    {formik.errors.ListOffileUpload[index]?.File}
                                  </div>
                                )}
                            </Col>
                          ))}
                          <Col lg={12} className="mt-2">
                            <button
                              className="btn btn-secondary"
                              type="button"
                              onClick={() => {
                                AddFileUpload();
                              }}
                            >
                              <i
                                className="fas fa-plus-circle"
                                style={{ color: "dodgerblue" }}
                              ></i>
                              &nbsp; Add More
                            </button>
                          </Col>

                          <Col lg={12}>
                            <text style={{ fontSize: "11px" }}>
                              You can upload a maximum of 10 files, 5MB each
                            </text>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <hr></hr>
                    <Row className="mt-3">
                      <Col lg={6}>
                        {invoice_status?.toLowerCase() !== "sent" ? (
                          <>
                            <button
                              className="btn btn-primary"
                              type="submit"
                              onClick={() => {
                                setFieldValue("button", "Save");
                              }}
                            >
                              Save
                            </button>
                            &nbsp;&nbsp;
                            <button
                              className="btn btn-secondary"
                              type="submit"
                              onClick={() => {
                                setFieldValue("button", "Save and Send");
                              }}
                            >
                              Save and Send
                            </button>
                            &nbsp;&nbsp;
                          </>
                        ) : (
                          ""
                        )}

                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => {
                            navigate("/purchase-order");
                          }}
                        >
                          Cancel
                        </button>
                      </Col>
                    </Row>
                  </Form>
                </FormikProvider>
              </Col>
            </Row>
            <SwalError
              showError={showSwalError}
              setShowError={setShowSwalError}
              ErrorMsg={swalErrorMsg}
            ></SwalError>
          </Container>
        </div>
        <Modal isOpen={PONoModal} centered={true} size="lg">
          <div className="modal-header mdl_header">
            <h5 className="modal-title mt-0">{"PO Purchase Number"}</h5>
            <button
              type="button"
              className="btn close mt-2"
              onClick={() => setPONoModal(false)}
            >
              <span>×</span>
            </button>
          </div>
          <div className="modal-body">
            <FormikProvider value={formikPONo}>
              <Form onSubmit={formikPONo.handleSubmit}>
                <Row className="mt-3">
                  <Col lg={12}>
                    Your order number are set on auto-generate mode to save your
                    time. Are you sure about changing this setting
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col lg={12}>
                    <Input
                      type="radio"
                      name="Setting"
                      id="Setting"
                      className="form-check-input"
                      onChange={(e) => {
                        //console.log(e.target.checked)
                        formikPONo.setFieldValue("Setting", e?.target.checked);
                        formikPONo.setFieldValue("AddManually", false);
                      }}
                      checked={Setting}
                    />
                    &nbsp;
                    <label className="custom-control-label" htmlFor="Setting">
                      Continue auto-generating order number
                    </label>
                  </Col>
                </Row>
                {Setting ? (
                  <>
                    <div className="table-responsive mt-3">
                      <table className="table table-bordered mb-0">
                        <thead>
                          <tr className="table-light">
                            <th style={{ minWidth: "200px" }}>Prefix</th>
                            <th style={{ minWidth: "200px" }}>Next Number</th>
                            <th style={{ minWidth: "50px" }}>Default</th>
                            <th style={{ minWidth: "80px" }}>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListofPurchaseOrderNumber &&
                            ListofPurchaseOrderNumber.map(
                              (paurchaseOrderNumber, index) => (
                                <tr>
                                  <td>
                                    <Field
                                      type="text"
                                      name={`ListofPurchaseOrderNumber.[${index}].Prefix`}
                                      placeholder={"Prefix"}
                                      component={CustomInput}
                                      style={{ textTransform: "Uppercase" }}
                                    />
                                  </td>
                                  <td>
                                    <Field
                                      type="number"
                                      name={`ListofPurchaseOrderNumber.[${index}].NextNumber`}
                                      placeholder={"Next Number"}
                                      component={CustomInput}
                                    />
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    <Input
                                      type="radio"
                                      name={`ListofPurchaseOrderNumber.[${index}].Default`}
                                      id={`ListofPurchaseOrderNumber.[${index}].Default`}
                                      className="form-check-input"
                                      onChange={(e) => {
                                        formikPONo.setFieldValue(
                                          `ListofPurchaseOrderNumber.[${index}].Default`,
                                          e?.target.checked
                                        );
                                      }}
                                      checked={paurchaseOrderNumber.Default}
                                    />
                                  </td>
                                  <td>
                                    <div className="d-flex">
                                      <Button
                                        className="btn btn-secondary waves-effect waves-light btn btn-secondary"
                                        style={{
                                          width: "25px",
                                          height: "25px",
                                          padding: "0px",
                                        }}
                                        onClick={() => {}}
                                        title="Edit"
                                      >
                                        <i
                                          className="fas fa-edit"
                                          style={{ color: "#17a98c" }}
                                        ></i>
                                      </Button>
                                      &nbsp;
                                      <Button
                                        className="btn btn-secondary waves-effect waves-light btn btn-secondary"
                                        style={{
                                          width: "25px",
                                          height: "25px",
                                          padding: "0px",
                                        }}
                                        title="Delete"
                                        onClick={() => {
                                          delete_PONumber(index);
                                        }}
                                      >
                                        <i
                                          className="fas fa-trash-alt"
                                          style={{
                                            color: "red",
                                          }}
                                        ></i>
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              )
                            )}
                        </tbody>
                      </table>
                    </div>
                    <Row className="mt-2">
                      <Col style={{ textAlign: "end" }}>
                        <button
                          className="btn btn-secondary"
                          type="button"
                          onClick={() => {
                            AddPONumber();
                          }}
                        >
                          <i
                            className="fas fa-plus-circle"
                            style={{ color: "dodgerblue" }}
                          ></i>
                          &nbsp; Add More
                        </button>{" "}
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}

                <Row className="mt-3">
                  <Col lg={12}>
                    <Input
                      type="radio"
                      name="AddManually"
                      id="AddManually"
                      className="form-check-input"
                      onChange={(e) => {
                        formikPONo.setFieldValue(
                          "AddManually",
                          e?.target.checked
                        );
                        formikPONo.setFieldValue("Setting", false);
                      }}
                      checked={AddManually}
                    />
                    &nbsp;
                    <label
                      className="custom-control-label"
                      htmlFor="AddManually"
                    >
                      I will add them manually each time
                    </label>
                  </Col>
                </Row>
                <hr></hr>
                <Row className="mt-3">
                  <Col lg={12} style={{ textAlign: "right" }}>
                    <button className="btn btn-primary" type="submit">
                      Save
                    </button>
                    &nbsp;&nbsp;
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => {
                        setPONoModal(false);
                      }}
                    >
                      Cancel
                    </button>
                  </Col>
                </Row>
              </Form>
            </FormikProvider>
          </div>
        </Modal>
        <Modal isOpen={editTermsAndConditionModal} centered={true} size="lg">
          <div className="modal-header mdl_header">
            <h5 className="modal-title mt-0">{"Terms and Condition"}</h5>
            <button
              type="button"
              className="btn close mt-2"
              onClick={() => setEditTermsAndConditionModal(false)}
            >
              <span>×</span>
            </button>
          </div>
          <div className="modal-body">
            <FormikProvider value={formikEditTermsAndCondition}>
              <Form onSubmit={formikEditTermsAndCondition.handleSubmit}>
                <Row>
                  {termsAndConditionsList?.map((x, i) => (
                    <>
                      <Col lg={12} className="mt-2">
                        <Input
                          type="checkbox"
                          name={`TermsAndCondition${i}`}
                          id={`TermsAndCondition${i}`}
                          className="form-check-input"
                          checked={x.checked}
                          onChange={(e) => {
                            let newArry = [...termsAndConditionsList];
                            newArry[i].checked = e.target.checked;
                            formikEditTermsAndCondition.setFieldValue(
                              "termsAndConditionsList",
                              newArry
                            );
                          }}
                        />
                        {/* </Col>
                      <Col
                        lg={11}
                        style={{ textAlign: "left" }}
                        className="mt-2"
                      > */}{" "}
                        &nbsp;&nbsp;
                        {x.Condition}
                      </Col>
                    </>
                  ))}
                </Row>
                <hr></hr>
                <Row className="mt-3">
                  <Col lg={12} style={{ textAlign: "right" }}>
                    <button className="btn btn-primary" type="submit">
                      Save
                    </button>
                    &nbsp;&nbsp;
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => {
                        setEditTermsAndConditionModal(false);
                      }}
                    >
                      Cancel
                    </button>
                  </Col>
                </Row>
              </Form>
            </FormikProvider>
          </div>
        </Modal>
        <Modal isOpen={disclaimerModal} centered={true}>
          <div className="modal-header mdl_header">
            <h5 className="modal-title mt-0">
              <text style={{ color: "black" }}>{"Disclaimer"}</text>{" "}
            </h5>
            <button
              type="button"
              className="btn close mt-2"
              onClick={() => setDisclaimerModal(false)}
            >
              <span>×</span>
            </button>
          </div>
          <div className="modal-body">
            <Row>
              <Col>
                <text>
                  Seller is not responsible for any differences that may occur
                  between freight estimates contained in a Quotation and actual
                  freight charges applicable at the time of shipment, and Buyer
                  shall incur and be responsible for all costs associated
                  therewith. Freight Charges.
                </text>
              </Col>
            </Row>
            <hr></hr>
            <Row>
              <Col lg={12} style={{ textAlign: "right" }}>
                <button
                  className="btn btn-light"
                  type="button"
                  onClick={() => {
                    setDisclaimerModal(false);
                  }}
                >
                  Cancel
                </button>
              </Col>
            </Row>
          </div>
        </Modal>
      </Spin>
    </React.Fragment>
  );
};
AddInvoice.propTypes = {
  t: PropTypes.any,
};
export default withRouter(withTranslation()(AddInvoice));
